import * as React from "react";
import i18n from "i18n";
import { observer } from "mobx-react";
import {
  Typography,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Radio,
  FormGroup,
  FormControlLabel,
  withStyles,
  Button,
} from "@material-ui/core";
import { ModelMapStore } from "modules/modelMap/ModelMapStore";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import { ModelMapFilter } from "modules/modelMap/models/ModelMapFilter";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";
import ErrorIcon from "@material-ui/icons/Error";
import { EModelMapTab } from "common/enums";

const styles = (theme) => ({
  layer: {
    position: "absolute" as any,
    height: "100%",
    width: "100%",
    overflow: "hidden",
    zIndex: 10,
  },
  title: {
    fontFamily: "Raleway",
    fontSize: "10px",
    fontWeight: 700,
    backgroundColor: "#2E2D2F",
    color: "#ABC200",
    padding: "10px 18px",
    textTransform: "uppercase" as any,
    letterSpacing: "1px",
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
  table: {
    display: "table",
    height: "calc((100vh - 68px) * 0.85)",
  },
  tableCell: {
    display: "table-cell",
    verticalAlign: "middle",
    padding: "0 25px",
    textAlign: "center" as any,
  },
  stageTitle: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 700,
    color: "rgba(255,255,255,0.87)",
  },
  stageSubtitle: {
    fontFamily: "Roboto",
    fontSize: "11px",
    fontWeight: 300,
    color: "rgba(255,255,255,0.67)",
  },
  headerContent: {
    padding: "0px 15px",
    height: 85,
  },
  formControl: {
    width: "100%",
    marginBottom: "25px",
  },
  origin: {
    paddingTop: "21px",
    fontFamily: "Roboto",
    fontSize: "11px",
    fontWeight: 400,
    color: "#e2e2e3",
  },
  button: {
    letterSpacing: "1px",
    font: "Raleway",
    fontWeight: 700,
    fontSize: "10px",
  },
  buttonApply: {
    "&:hover": {
      backgroundColor: "#000000",
    },
    letterSpacing: "1px",
    font: "Raleway",
    fontWeight: 700,
    fontSize: "10px",
    color: "rgba(255, 255, 255, 0.6)",
    marginLeft: "15px",
    backgroundColor: "rgba(39, 39, 39, 1)",
    borderColor: "rgba(29, 29, 29, 1)",
  },
  filterCheck: {
    color: "rgba(255, 255, 255, 0.6)",
    "&$checked": {
      color: "rgba(171, 194, 0, 1)",
    },
    "&:nth-child(2)": {
      color: "white",
    },
  },
});

type IProps = {
  classes: any;
};

const mmFilterOperations = [
  {
    value: 0,
    operation: "==",
    label: i18n.modelMaps.filter.operations.equal,
  },
  {
    value: 1,
    operation: "<",
    label: i18n.modelMaps.filter.operations.lessThan,
  },
  {
    value: 2,
    operation: ">",
    label: i18n.modelMaps.filter.operations.greaterThan,
  },
  {
    value: 3,
    operation: "in",
    label: i18n.modelMaps.filter.operations.contains,
  },
  // PRUBK-608: Inserir novos filtros - notin(Não contém), blank(Em branco), filled(Preenchido) no Take Off Itens O(Model Maps)
  {
    value: 4,
    operation: "notin",
    label: i18n.modelMaps.filter.operations.notcontains,
  },
  {
    value: 5,
    operation: "blank",
    label: i18n.modelMaps.filter.operations.blank,
  },
  {
    value: 4,
    operation: "filled",
    label: i18n.modelMaps.filter.operations.filled,
  },
];

@observer
class TakeOffItemProperties extends React.Component<IProps> {
  state = {
    selectedNewFilter: "-1",
  };

  handleChangeFilter = (event) => {
    TakeOffStore[event.target.name] = event.target.value;
  };

  handleChangeRadio = (event) => {
    TakeOffStore.selectedRadio = event.target.value;
    //this.setState({ selectedRadio: event.target.value });
  };

  handleChangeFilterValue = (prop) => (event) => {
    TakeOffStore[prop] = event.target.value;
    //this.setState({ [prop]: event.target.value });
  };

  handleClickApplyFilter = (event) => {
    TakeOffStore.clearTakeOffModelMap();

    let takeOffModelMapId = TakeOffStore.takeOffModelMap
      ? TakeOffStore.takeOffModelMap.id
      : "";

    let indexSelected = TakeOffStore.takeOffFormatedList.findIndex(
      (i) => i.id == takeOffModelMapId
    );

    let list = TakeOffStore.takeOffFormatedList[indexSelected]
      ? TakeOffStore.takeOffFormatedList[indexSelected].data
      : new Array();
    let field =
      TakeOffStore.selectedColumn != undefined
        ? TakeOffStore.selectedColumn.column
        : "";
    let firstOperation =
      TakeOffStore.firstFilter === -1
        ? ""
        : TakeOffStore.firstFilter.toString();
    let firstFilter = new ModelMapFilter(
      field,
      firstOperation,
      TakeOffStore.firstFilterValue,
      "and"
    );

    let secondOperation =
      TakeOffStore.secondFilter === -1
        ? ""
        : TakeOffStore.secondFilter.toString();
    let secondFilter = new ModelMapFilter(
      field,
      secondOperation,
      TakeOffStore.secondFilterValue,
      TakeOffStore.selectedRadio
    );

    let filterArray = new Array();
    // PRUBK-608: Inserir novos filtros - notin(Não contém), blank(Em branco), filled(Preenchido) no Take Off Itens O(Model Maps)
    if (
      (firstFilter.operation === "blank" ||
        firstFilter.operation === "filled") &&
      firstFilter.operationValue === ""
    ) {
      filterArray.push(firstFilter);
    }
    //
    if (firstFilter.operation !== "" && firstFilter.operationValue !== "")
      filterArray.push(firstFilter);
    if (
      secondFilter.operation !== "" &&
      secondFilter.operationValue !== "" &&
      secondFilter.logicalOperator !== ""
    )
      filterArray.push(secondFilter);

    if (TakeOffStore.hasErrorFilter) {
      if (this.state.selectedNewFilter == "-1") {
        alert("Você deve escolher um novo filtro!");
        return;
      }

      ModelMapStore.saveFilters([], field);

      for (let i = 0; i < filterArray.length; i++) {
        filterArray[i].field = this.state.selectedNewFilter;
      }
      ModelMapStore.saveFilters(filterArray, this.state.selectedNewFilter);
      TakeOffStore.setSwipeTab(EModelMapTab.FILTER);
      ModelMapStore.modelMapFormat = [];

      let filterErrors;
      if (
        TakeOffStore.takeOffModelMap &&
        TakeOffStore.takeOffModelMap.data.filterErrors
      ) {
        filterErrors = TakeOffStore.takeOffModelMap.data.filterErrors.filter(
          (x) => x != TakeOffStore.selectedColumn.column
        );

        if (filterErrors.length > 0) {
          TakeOffStore.takeOffModelMap.data.filterErrors = filterErrors;
        } else {
          if (TakeOffStore.takeOffModelMap.data.filterErrors) {
            delete TakeOffStore.takeOffModelMap.data.filterErrors;
          }
        }
        ModelMapStore.updateModelMap(TakeOffStore.takeOffModelMap);
        TakeOffStore.setSwipeTab(EModelMapTab.FILTER);
        ModelMapStore.modelMapFormat = [];
      }
      if (
        filterErrors.length <= 0 &&
        TakeOffStore.takeOffModelMap &&
        TakeOffStore.takeOffModelMap.data
      ) {
        delete TakeOffStore.takeOffModelMap.data.filterErrors;
      }
    } else {
      ModelMapStore.saveFilters(filterArray, field);
    }
    if (
      TakeOffStore.takeOffModelMap &&
      (TakeOffStore.takeOffModelMap.data.formatErrors === undefined ||
        TakeOffStore.takeOffModelMap.data.formatErrors.length == 0) &&
      list.length > 0
    ) {
      ModelMapStore.saveFormat(true);
    }

    TakeOffStore.hasErrorFilter = false;
  };

  handleClickClearFilter = (event) => {
    TakeOffStore.clearTakeOffModelMap();

    TakeOffStore.firstFilter = -1;
    TakeOffStore.secondFilter = -1;
    TakeOffStore.firstFilterValue = "";
    TakeOffStore.secondFilterValue = "";
    TakeOffStore.selectedRadio = "and";
    let field =
      TakeOffStore.selectedColumn != undefined
        ? TakeOffStore.selectedColumn.column
        : "";
    ModelMapStore.saveFilters([], field);

    let takeOffModelMapId = TakeOffStore.takeOffModelMap
      ? TakeOffStore.takeOffModelMap.id
      : "";

    let indexSelected = TakeOffStore.takeOffFormatedList.findIndex(
      (i) => i.id == takeOffModelMapId
    );

    let list = TakeOffStore.takeOffFormatedList[indexSelected]
      ? TakeOffStore.takeOffFormatedList[indexSelected].data
      : new Array();
    if (TakeOffStore.hasErrorFilter) {
      let filterErrors;
      if (
        TakeOffStore.takeOffModelMap &&
        TakeOffStore.takeOffModelMap.data.filterErrors
      ) {
        filterErrors = TakeOffStore.takeOffModelMap.data.filterErrors.filter(
          (x) => x != TakeOffStore.selectedColumn.column
        );

        if (filterErrors.length > 0) {
          TakeOffStore.takeOffModelMap.data.filterErrors = filterErrors;
        } else {
          if (TakeOffStore.takeOffModelMap.data.filterErrors) {
            delete TakeOffStore.takeOffModelMap.data.filterErrors;
          }
        }

        ModelMapStore.updateModelMap(TakeOffStore.takeOffModelMap);

        TakeOffStore.setSwipeTab(EModelMapTab.FILTER);
        ModelMapStore.modelMapFormat = [];
        TakeOffStore.hasErrorFilter = false;
      }
    }
    if (
      TakeOffStore.takeOffModelMap &&
      (TakeOffStore.takeOffModelMap.data.formatErrors === undefined ||
        TakeOffStore.takeOffModelMap.data.formatErrors.length == 0) &&
      list.length > 0
    ) {
      ModelMapStore.saveFormat(true);
    }
  };

  handleChangeFilterIndex = (event) => {
    this.setState({ selectedNewFilter: event.target.value });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.layer}>
        <Typography className={classes.title} component="div">
          PROPRIEDADES
        </Typography>
        {/* && !TakeOffStore.isFormating // *BRUNO* removido por bloquear o restante do componente */}
        {TakeOffStore.selectedColumn !== undefined &&
          TakeOffStore.swipeTab === EModelMapTab.FILTER && (
            <div style={{ width: "100%", height: "100%" }}>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  backgroundColor: "#363637",
                  padding: "16px",
                }}
              >
                <FormControl className={classes.formControl}>
                  <InputLabel htmlFor="first-filter">Filtro</InputLabel>
                  <br />
                  {TakeOffStore.hasErrorFilter && (
                    <div>
                      <div style={{ height: 30, float: "left" }}>
                        <ErrorIcon
                          style={{
                            color: "#FB4436",
                            padding: "2px",
                            margin: "5",
                            fontSize: "20px",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          color: "#737373",
                          height: "30px",
                          lineHeight: "30px",
                          fontSize: 11,
                        }}
                      >
                        Filtro: {TakeOffStore.selectedColumn.column}
                      </div>
                    </div>
                  )}

                  {TakeOffStore.hasErrorFilter && (
                    <>
                      <Select
                        displayEmpty={true}
                        value={this.state.selectedNewFilter}
                        onChange={this.handleChangeFilterIndex}
                        inputProps={{
                          name: "firstFilter",
                          id: "first-filter",
                        }}
                      >
                        <MenuItem value="-1" disabled>
                          Selecione outro campo
                        </MenuItem>
                        {TakeOffStore.takeOffColumns.map(
                          (option, ndx) =>
                            option !== "Contador" && (
                              <MenuItem key={ndx} value={option}>
                                {option}
                              </MenuItem>
                            )
                        )}
                      </Select>
                      <br />
                    </>
                  )}
                  <Select
                    displayEmpty={true}
                    value={TakeOffStore.firstFilter}
                    onChange={this.handleChangeFilter}
                    inputProps={{
                      name: "firstFilter",
                      id: "first-filter",
                    }}
                  >
                    <MenuItem value="-1" disabled>
                      Selecione uma condição
                    </MenuItem>
                    {mmFilterOperations.map((option) => (
                      <MenuItem key={option.value} value={option.operation}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                  <TextField
                    fullWidth
                    margin="normal"
                    placeholder="Digite um valor"
                    onChange={this.handleChangeFilterValue("firstFilterValue")}
                    value={TakeOffStore.firstFilterValue}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <FormGroup row>
                    <FormControlLabel
                      style={{ color: "rgba(255, 255, 255, 0.6) !important" }}
                      control={
                        <Radio
                          className={classes.filterCheck}
                          checked={TakeOffStore.selectedRadio === "and"}
                          onChange={this.handleChangeRadio}
                          value="and"
                          name="radio-button"
                          aria-label="And"
                          icon={
                            <RadioButtonUncheckedIcon
                              fontSize="small"
                              className={classes.filterCheck}
                            />
                          }
                          checkedIcon={
                            <RadioButtonCheckedIcon
                              fontSize="small"
                              className={classes.filterCheck}
                            />
                          }
                        />
                      }
                      label={
                        <span style={{ color: "white", letterSpacing: "1px" }}>
                          E
                        </span>
                      }
                    />
                    <FormControlLabel
                      style={{ color: "rgba(255, 255, 255, 0.6) !important" }}
                      control={
                        <Radio
                          className={classes.filterCheck}
                          checked={TakeOffStore.selectedRadio === "or"}
                          onChange={this.handleChangeRadio}
                          value="or"
                          name="radio-button"
                          aria-label="Or"
                          icon={
                            <RadioButtonUncheckedIcon
                              fontSize="small"
                              className={classes.filterCheck}
                            />
                          }
                          checkedIcon={
                            <RadioButtonCheckedIcon
                              fontSize="small"
                              className={classes.filterCheck}
                            />
                          }
                        />
                      }
                      label={
                        <span style={{ color: "white", letterSpacing: "1px" }}>
                          OU
                        </span>
                      }
                    />
                  </FormGroup>
                  <Select
                    displayEmpty
                    value={TakeOffStore.secondFilter}
                    onChange={this.handleChangeFilter}
                    inputProps={{
                      name: "secondFilter",
                      id: "second-filter",
                    }}
                  >
                    <MenuItem value="-1" disabled>
                      Selecione uma condição
                    </MenuItem>

                    {mmFilterOperations.map((option) => (
                      <MenuItem key={option.value} value={option.operation}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>

                  <TextField
                    fullWidth
                    margin="normal"
                    placeholder="Digite um valor"
                    onChange={this.handleChangeFilterValue("secondFilterValue")}
                    value={TakeOffStore.secondFilterValue}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />

                  <FormGroup
                    style={{ flexDirection: "row-reverse", margin: "15px 0px" }}
                  >
                    <Button
                      variant="outlined"
                      size="small"
                      className={classes.buttonApply}
                      onClick={this.handleClickApplyFilter}
                    >
                      Aplicar
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      className={classes.button}
                      style={{
                        color: "rgba(112, 112, 112, 1)",
                        borderColor: "rgba(112, 112, 112, 1)",
                      }}
                      onClick={this.handleClickClearFilter}
                    >
                      Limpar
                    </Button>
                  </FormGroup>
                </FormControl>
              </div>
            </div>
          )}
      </div>
    );
  }
}
export default withStyles(styles)(TakeOffItemProperties);



// WEBPACK FOOTER //
// ./src/modules/takeOff/components/layouts/TakeOffItemProperties.tsx